"use strict";
/**
 * Stock Calculation Request Types
 *
 * Request DTOs for stock calculation endpoints.
 */
Object.defineProperty(exports, "__esModule", { value: true });
